import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TimezoneService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class TimezoneDateInterceptorService implements HttpInterceptor {
  constructor(private timezoneService: TimezoneService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const body = this.normalizeBody(req.body);

    return next.handle(body === req.body ? req : req.clone({ body }));
  }

  private normalizeBody(body: any): any {
    if ([null, undefined].includes(body)) {
      return body;
    }

    if (body instanceof FormData || body instanceof Blob || body instanceof ArrayBuffer) {
      return body;
    }

    if (body instanceof Date) {
      return this.timezoneService.toApiHttpDate(body);
    }

    if (Array.isArray(body)) {
      return body.map((item) => this.normalizeBody(item));
    }

    if (typeof body === 'object') {
      return Object.entries(body).reduce<Record<string, any>>((accumulator, [key, value]) => {
        accumulator[key] = this.normalizeBody(value);
        return accumulator;
      }, {});
    }

    return body;
  }
}
